import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/productPrice'

export const productPriceService = {
    search,
    syncNoPromoPrices,
    syncSingleProductPrices,
    syncPromotionsPrices,
    syncSinglePromotionPrices,
    syncSingleProduccInPromotionPrices,
    syncFirebase
};

function search(data, offset, max) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', data)
}

function syncNoPromoPrices() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncNoPromoPrices`, 'GET',{})
}

function syncSingleProductPrices(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncSingleProductPrices`, 'POST', {data:data})
}

function syncPromotionsPrices() {
    return utilHelper.doRequest(`${relativeUrl}/syncPromotionsPrices`, 'GET')
}

function syncSinglePromotionPrices(data) {
    return utilHelper.doRequest(`${relativeUrl}/syncSinglePromotionPrices`, 'POST', data)
}

function syncSingleProduccInPromotionPrices(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncSingleProduccInPromotionPrices`, 'POST', {data:data})
}

function syncFirebase(data) {
    return utilHelper.doRequest(`${relativeUrl}/getPromoProducts`, 'POST', {data:data})
}